/* eslint-disable no-use-before-define */
import React, { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Chip,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  Typography,
  makeStyles
} from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import BorderAllIcon from '@material-ui/icons/BorderAll';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import HomeIcon from '@material-ui/icons/Home';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined';
import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import SpeakerNotesOutlinedIcon from '@material-ui/icons/SpeakerNotesOutlined';
import FeedbackOutlinedIcon from '@material-ui/icons/FeedbackOutlined';
import GridOnIcon from '@material-ui/icons/GridOn'

import {
  Briefcase as BriefcaseIcon,
  Calendar as CalendarIcon,
  ShoppingCart as ShoppingCartIcon,
  Folder as FolderIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  UserPlus as UserPlusIcon,
  AlertCircle as AlertCircleIcon,
  Trello as TrelloIcon,
  User as UserIcon,
  Layout as LayoutIcon,
  Edit as EditIcon,
  DollarSign as DollarSignIcon,
  Mail as MailIcon,
  MessageCircle as MessageCircleIcon,
  PieChart as PieChartIcon,
  Share2 as ShareIcon,
  Users as UsersIcon,
  Database as DbIcon,
  Package as PackageIcon
} from 'react-feather';

import Logo from 'src/components/Logo';
import useAuth from 'src/hooks/useAuth';
import usePlantTerminology from 'src/hooks/usePlantTerminology';
import NavItem from './NavItem';

import { useTranslation, withNamespaces } from 'react-i18next';
import { random } from 'lodash';



function renderNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
}


function reduceChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth;
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;

}

function findPermissionItem({ data, idprofilo }) {
  if (data != undefined) {
    var find = data.permission.find(x => x == idprofilo);
    if (find != undefined) {
      return true
    }
  }
  return false;
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useAuth();
  const { getPlantLabel, isPlant3 } = usePlantTerminology();
  const { t, i18n } = useTranslation();

//  console.log('Current user:', user);

  const sections1 =
  //const sectionsPlant1 =
    [
      {
        permission: [1,8,3],
        items: [
          {
            title: t('Home'),
            icon: HomeIcon,
            href: '/app/reports/dashboard-kpi',
            permission: [1, 2,8,3]
          }
        ]
      },
      {
        subheader: "Plant Layout",
        permission: [1, 2,8,3],
        items: [
          {
            title: "Plant Layout",
            icon: GridOnIcon,
            href: "/app/plantlayout"
          }
        ]
      },
      {
        subheader: t('Management PM'),
        permission: [1, 2,8,3],
        items: [
          {
            title: t('StutturaMacchina'), // 'Dashboard',
            icon: AccountTreeIcon,
            href: '/app/mgmt/equipStructure'
          },
          /* ...((user.iduser === 205 || user.iduser === 2) ? [ */ {
            title: t('DettaglioMacchina'),
            icon: ReceiptIcon,
            href: '/app/mgmt/equipStructureMD'
          } /* ] : []) */,
          {
            title: t('MetodoSMP'),
            icon: DescriptionOutlinedIcon,
            href: '/app/mgmt/smp'
          },
          {
            title: t('Manutenzione'),
            icon: ScheduleOutlinedIcon,
            href: '/app/mgmt/maintenance'
          },
          {
            title: t('CalendarioPM'),
            icon: CalendarTodayIcon,
            //href: '/app/mgmt/PMcalendar'
            href: '/app/mgmt/PMcalendar3'
          },
          {
            title: t('Workorders'),
            icon: ListAltOutlinedIcon,
            href: '/app/mgmt/workorders'
          },          
          /* {
            title: t('CalendarioLub'),
            icon: CalendarTodayIcon,
            href: '/app/mgmt/PMlubricant'
          },  */
          /* {
            title: t('Machine Ledger'),
            icon: BorderAllIcon,
            href: '/app/mgmt/MachineLedger'
          }, */
          {
            title: t('Magazzino'),
            icon: PackageIcon,
            href: '/app/mgmt/warehouse'
          }, 
          /* {
            title: t('Cataloghi'),
            icon: FolderIcon,
            items: [
              {
                title: t('Strumenti di Controllo'),
                href: '/app/mgmt/catalogs/controltools'
              },
              {
                title: t('Lubrificanti'),
                href: '/app/mgmt/catalogs/lubfrificants'
              },
              {
                title: t('Materiali Ausiliari'),
                href: '/app/mgmt/catalogs/auxiliarymaterials'
              },
              {
                title: t('Attrezzi'),
                href: '/app/mgmt/catalogs/tools'
              },
            ]
          }, */
        ]
      },
      {
        //subheader: t('Management AM'),
        permission: [1, 3,8],
        items: [
           /* {
            title: "Reporting AM", // 'Dashboard',
            icon: CalendarTodayIcon,
            //href: '/app/mgmt/'
            href: '/app/mgmtAM/AMReporting'
          },
          {
            title: t('Calendar AM'), // 'Dashboard',
            icon: CalendarTodayIcon,
            //href: '/app/mgmt/'
            href: '/app/mgmtAM/AMCalendar'
          },
          {
            title: t('StutturaMacchina'), // 'Dashboard',
            icon: AccountTreeIcon,
            //href: '/app/mgmt/'
            href: '/app/mgmtAM/equipStructure'
          }, */
          {
            title: t('Metodo SOP'),
            icon: ReceiptIcon,
            href: '/app/mgmtAM/sop'
          },
          /* {
            title: t('Manutenzione'),
            icon: ReceiptIcon,
            href: '/app/mgmtAM/maintenance',
          },
          {
            title: t('Percorsi'),
            icon: ReceiptIcon,
            href: '/app/mgmtAM/path/equipSelection',
          },
          {
            title: t('CILR'),
            icon: ReceiptIcon,
            href: '/app/mgmtAM/cilr/equipSelection',
          } */


        ]
      },
      {
        subheader: t('Organizzazione'),
        permission: [1,8,3],
        items: [
          {
            title: t(getPlantLabel('navbar')),
            icon: FormatListNumberedIcon,
            href: '/app/planning/maintenanceCycles'
          },
          {
            title: t('Gestione Operatori'),
            icon: AssignmentIndIcon,
            href: '/app/planning/mgmtOperators'
          },
          {
            title: t('Gestione Squadre'),
            icon: PeopleAltIcon,
            href: '/app/planning/mgmtTeams'
          },
          {
            title: t('Assegnazioni'),
            icon: FolderIcon,
            href: '/app/management/products',
            items: [
              // {
              //   title: t('Ewo'),
              //   href: '/app/planning/ewo/assign'
              // },
              {
                title: t('Tag'),
                href: '/app/planning/tag/assign'
              }
            ]
          },
          /* {
            title: t('Causa Radice'),
            icon: ReceiptIcon,
            href: '/app/management/RootCauseAnalysis',
            permission: [1,3,8]
          }, */
          {
            title: t('Nuova Richiesta'),
            icon: FolderIcon,
            href: '/app/management/products',
            items: [
              {
                title: t('Nuovo TAG'),
                icon: SpeakerNotesOutlinedIcon,
                href: '/app/planning/tag/equipment?view=desktop',
                permission: [1,3,8]
              },
              // {
              //   title: t('Nuova EWO'),
              //   icon: FeedbackOutlinedIcon,
              //   href: '/app/planning/ewo/equipment?view=desktop',
              //   permission: [1]
              // }
            ]
          },
          {
            title: t('Elenco tag/ewo creati'),
            icon: FolderIcon,
            href: '/app/management/products',
            items: [
              {
                title: t('Tag'),
                icon: SpeakerNotesOutlinedIcon,
                href: '/app/planning/tag/list',
                permission: [1,3,8]
              },
              // {
              //   title: t('Ewo'),
              //   icon: FeedbackOutlinedIcon,
              //   href: '/app/planning/ewo/list',
              //   permission: [1]
              // }
            ]
          },
          {
            title: "Report",
            icon: FolderIcon,
            href: '/app/management/products',
            items: [
              {
                title: "KPI",
                href: '/app/planning/report/Kpi'
              },
              {
                title: "Calcola KPI",
                href: '/app/planning/report/CalcolaKpi'
              }
            ]
          },

        ]
      },
/*    {
        subheader: t('Esecuzione'),
        permission: [1, 2],
        items: [
          {
            title: t('Interventi Programmati'),
            href: '/app/tablet/homeTablet',
            icon: ReceiptIcon
          },
          {
            title: t('EWO'),
            href: '/app/execution/ewo',
            icon: ReceiptIcon
          },
          {
            title: t('TAG'),
            href: '/app/execution/tag',
            icon: ReceiptIcon
          },
          {
            title: t('Nuovo TAG'),
            icon: ReceiptIcon,
            href: '/app/planning/tag/equipment'
          },
          {
            title: t('Nuova EWO'),
            icon: ReceiptIcon,
            href: '/app/planning/ewo/equipment'
          },
        ]
      }, */
      {
        subheader: t('Configurazione'),
        permission: [1,8,3],
        items: [
          {
            title: t('Librerie impianto'),
            icon: FolderIcon,
            href: '/app/management/products',
            items: [
              {
                title: t('Tipologie Macchine'),
                href: '/app/configuration/equipmentArchives/libMachineTipology'
              },
              {
                title: t('Tipologie Gruppi'),
                href: '/app/configuration/equipmentArchives/libGroup'
              },
              {
                title: t('Tipologie Sottogruppi'),
                href: '/app/configuration/equipmentArchives/libSubgroup'
              },
              {
                title: t('Tipologie Componenti'),
                href: '/app/configuration/equipmentArchives/libComponent'
              }
            ]
          },
          ...(isPlant3
	        ? [
            {
              title: t('Altre Librerie'),
              icon: FolderIcon,
              href: '/app/management/products',
              permission: [1,8,3],
              items: [
                {
                  title: t('Costruttori'),
                  href: '/app/configuration/othersArchives/libManufacturer'
                },
                {
                  title: t('Tipologia Lubrificanti'),
                  href: '/app/configuration/othersArchives/libLubrificant'
                },
                {
                  title: t('Grandezze fisiche'),
                  href: '/app/configuration/othersArchives/libPhisicalQty'
                },
                {
                  title: t('Tipologia Materiali'),
                  href: '/app/configuration/othersArchives/libMaterials'
                },
                {
                  title: t('Tipologia Attrezzi'),
                  href: '/app/configuration/othersArchives/libTools'
                },
                {
                  title: t('Tipologia Strumenti'),
                  href: '/app/configuration/othersArchives/libControlTools'
                }
              ]
            },
            {
              title: t('Libreria Skill'),
              href: '/app/extra/forms',
              icon: FolderIcon,
              permission: [2],
              items: [
                {
                  title: t('Capacita'),
                  href: '/app/management/libskill/capacity'
                },
                {
                  title: t('Gruppo professionale'),
                  href: '/app/management/libskill/professionalgroups'
                },
                {
                  title: t('Tipologia Skill'),
                  href: '/app/management/libskill/tipology'
                }
              ]
            },
            {
              title: t('Controlli'),
              href: '/app/configuration/controls',
              icon: FolderIcon
            }]
	        : []),
          {
            title: "Users",
            href: '/app/configuration/users',
            icon: FolderIcon
          },
          /* {
            title: "Data ingestion",
            href: '/app/configuration/dataingestion',
            icon: DbIcon
          },
          {
            title: "Other users",
            href: '/app/operator/homeOperator',
            icon: DbIcon
          } */



        ]
      }

    ];

    /* const sectionsPlant3 = sectionsPlant1

    const sections = isPlant3
      ? sectionsPlant3
      : sectionsPlant1; */

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box
            p={2}
            display="flex"
            justifyContent="center"
          >
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>
        </Hidden>

        <Box p={2}>
          {
            sections1.map((section) => (
            //sections.map((section) => (
              findPermissionItem({ data: section, idprofilo: user.idprofilo }) &&
              <List
                key={section.subheader + random()}
                subheader={(
                  <ListSubheader
                    disableGutters
                    disableSticky
                  >
                    {section.subheader}
                  </ListSubheader>
                )}
              >
                {
                  renderNavItems({ items: section.items, pathname: location.pathname })
                }

              </List>
            ))}
        </Box>
        <Divider />
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
        {/*   <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer> */}
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
